import { render, staticRenderFns } from "./TransformActions.vue?vue&type=template&id=a0ab341a&"
import script from "./TransformActions.vue?vue&type=script&lang=js&"
export * from "./TransformActions.vue?vue&type=script&lang=js&"
import style0 from "./TransformActions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports